import script from "./PaintingsLog.vue?vue&type=script&setup=true&lang=js"
export * from "./PaintingsLog.vue?vue&type=script&setup=true&lang=js"

import "./PaintingsLog.vue?vue&type=style&index=0&id=447f1e67&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447f1e67"]])

export default __exports__